<template>
  <cd-layout>
    <template #page-title>
      Payment Options
    </template>

    <template #page-meta>
      Swipe your card or Place your hand
    </template>

    <template #page-body>
      <div class="options">
        <div class="options-item">
          <div class="options-icon">
            <img src="../assets/images/svg/icon-swipe_card.svg" alt="" />
          </div>
          <div class="options-title">
            Swipe Card
          </div>
        </div>

        <div class="options-item">
          <div class="options-icon">
            <img src="../assets/images/svg/icon-place_hand.svg" alt="" />
          </div>
          <div class="options-title">
            Place Hand
          </div>
        </div>
      </div>
    </template>
  </cd-layout>
</template>
<script>
import CdLayout from '../layouts/CdLayout'

export default {
  name: 'Options',
  components: {
    CdLayout
  },
  data () {
    return {}
  },
  methods: {},
  computed: {}
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/Options.vue